class VaccinationController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, $stateParams, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        let schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
            //Meteor.subscribe('getMedicalInventoryList', schoolId);
            //Meteor.subscribe('getImmuzationReply', schoolId)
        $scope.selectedUsers = localStorageService.get('selectedUsers')
        authService.callAPI(MEDICALCONSTANT.API_GET_VACCINATION_LIST + schoolId, "GET", {}, (response) => {
                if (response.result && response.result.data && response.result.data.data) {
                    if (response.result.data.data.length > 0)
                        $scope.medicineList = response.result.data.data
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            })
        $scope.selectedMedicine = (medicineName) => {
                    $scope.batchIds = []
                    _.each($scope.medicineList, function(eachPdt) {
                        if (eachPdt.medicine_name === medicineName) {
                            $scope.batchIds.push({
                                'batch_no': eachPdt.batch_no,
                                'exp_date': eachPdt.exp_date
                            })

                        }
                    })
                    $scope.batchIds.sort(function(a, b) {
                        var nameA = a.exp_date
                        var nameB = b.exp_date
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });
                }
                $scope.selectedBatchId = (batchId) => {
                    if ($scope.batchIds[0].batch_no !== batchId)
                        $scope.expDateError = "Please select first batchId in the list having least expiry date"
                    else
                        $scope.expDateError = null
                }
            /*$scope.autorun(() => {
                if ($scope.selectedUsers.length > 0) {
                    $scope.selectedUsersForVaccination = []
                    _.each($scope.selectedUsers, function(eachUser) {
                            $scope.getDiagnosticReply = Doctor_Immunization.findOne({
                                "type": "reply",
                                "user_id": eachUser.user_id,
                                "doctor_id": Meteor.userId()
                            })
                            if ($scope.getDiagnosticReply && $scope.getDiagnosticReply.status == "replied")
                                $scope.selectedUsersForVaccination.push(eachUser)

                        })
                }
            })*/
            /*$scope.autorun(() => {
                $scope.productList = Medical_Inventory.find({
                    category: "Vaccines"
                }, {
                    sort: {
                        added_date: -1
                    }
                }).fetch()
                $scope.medicineList = []
                Meteor.call("currentDate", function(error, result) {
                    if (result) {
                        _.each($scope.productList, function(eachPdt) {
                            if (result < eachPdt.exp_date && eachPdt.remaining_count > 0) {
                                $scope.medicineList
.push(eachPdt)
                            }
                        })
                        $scope.$apply()
                    }
                })


                $scope.selectedMedicine = (medicineName) => {
                    $scope.batchIds = []
                    _.each($scope.medicineList, function(eachPdt) {
                        if (eachPdt.medicine_name === medicineName) {
                            $scope.batchIds.push({
                                'batch_no': eachPdt.batch_no,
                                'exp_date': eachPdt.exp_date
                            })

                        }
                    })
                    $scope.batchIds.sort(function(a, b) {
                        var nameA = a.exp_date
                        var nameB = b.exp_date
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });
                }
                $scope.selectedBatchId = (batchId) => {
                    if ($scope.batchIds[0].batch_no !== batchId)
                        $scope.expDateError = "Please select first batchId in the list having least expiry date"
                    else
                        $scope.expDateError = null
                }

            })*/
        $scope.today = new Date()
        $scope.vaccination = {}
        if ($stateParams.studentId !== true && $stateParams.is_edit === true && $stateParams.data !== true) {
            $scope.isEdit = true
            $scope.vaccination.vaccination_name = $stateParams.data.vaccine_name
            $scope.vaccination.manufactured_date = $stateParams.data.mfg_date
            $scope.vaccination.expiry_date = $stateParams.data.expiry_date
            $scope.vaccination.remarks = $stateParams.data.remarks
            $scope.vaccination.vaccination_batch = $stateParams.data.batch_no
        }
        $scope.vaccinationSubmit = () => {
            $scope.errors = {}
            let errorCount = 0
            var obj = {
                vaccination_name: ($scope.vaccination.vaccination_name) ? $scope.vaccination.vaccination_name : null,
                remarks: ($scope.vaccination.remarks) ? $scope.vaccination.remarks : null,
                vaccination_batch: ($scope.vaccination.vaccination_batch) ? $scope.vaccination.vaccination_batch : null,
                follow_up: ($scope.vaccination.follow_up) ? $scope.vaccination.follow_up : null,
                selected_users: $scope.selectedUsers,
                user_id: userId
            }

            if (errorCount === 0) {
                if ($stateParams.is_edit === true && $stateParams.data !== true) {
                    Meteor.call("editVaccinationIncident", obj, $scope.selectUser, $stateParams.data._id, function(error, result) {
                        if (error) {
                            toastr.error(error.reason);
                        } else {
                            toastr.success("Successfully edited");
                            $state.go("medicalUserProfile", {
                                userId: $scope.selectUser
                            })
                        }
                    })
                } else {
                    if ($scope.selectedUsersForVaccination && $scope.selectedUsersForVaccination.length > 0)
                        $scope.selectedUsers = $scope.selectedUsersForVaccination
                    if ($scope.expDateError === null) {
                         authService.callAPI(MEDICALCONSTANT.API_SAVE_VACCINATION_DETAILS, "POST", obj, (response) => {
                            if (response.result && response.result.data && response.result.data.data) {
                                $state.go("userProfile")
                            }
                        })
                    }
                }
            }
        }
    }
}
export default VaccinationController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/incidents/createVaccinationForm.js